export default __webpack_public_path__ + "static/media/home.b789e09f.png";